import { Close, Print } from '@mui/icons-material';
import { Button, Card, CardHeader, Chip, Grid, IconButton, Typography } from '@mui/material';
import { Box } from '@mui/system';
import PreviewOfPatientTable from './PrintTable';
import { useSelector } from 'react-redux';
import moment from 'moment';
import useCurrentUser from 'src/hooks/use-current-user';

type Props = {
  close?: any;
  patientTaskList: any;
  selectedTherapist: any;
  selectedDate: any;
};

const PrintPatient = (props: Props) => {
  const { close, patientTaskList, selectedTherapist, selectedDate } = props;
  const [credentials, firstName, lastName] = useCurrentUser(['credentials', 'firstName', 'lastName'])
  
  const getTherapistProfileData = useSelector((state: any) => state.getTherapistProfileReducer);
  const handlePrintDoc = () => {
    window.print();
  };
  const todayDate = moment(selectedDate).format('dddd, MMMM DD, YYYY');
  return (
    <Grid
      sx={{ width: 'max-content', '@media print': { width: '100%' } }}
      container
      direction={'column'}
    >
      <Grid
        container
        justifyContent={'space-between'}
        alignItems={'center'}
        py={3}
        sx={{ '@media print': { display: 'none' } }}
        px={3}
      >
        <Grid>
          <Typography variant="h5">Preview Print Schedule</Typography>
        </Grid>
        <Grid>
          <Button
            onClick={handlePrintDoc}
            startIcon={<Print />}
            variant="contained"
            sx={{ mr: 2 }}
          >
            Print
          </Button>
          <IconButton onClick={close}>
            <Close sx={{ color: '#000000' }} />
          </IconButton>
        </Grid>
      </Grid>
      <Grid
        p={5}
        ml={11}
        sx={{
          display: 'none',
          '@media print': {
            display: 'block',
            pb: 0,
          },
        }}
      >
        <Box sx={{ display: 'flex' }}>
          <Typography variant="subtitle2">Therapist name: </Typography>
          <Typography variant="body2">
            &nbsp;
            {selectedTherapist?.name}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', pt: 0.5 }}>
          <Typography variant="subtitle2">Credentials: </Typography>
          <Typography variant="body2">
            &nbsp;
            {selectedTherapist?.credentials}
          </Typography>
        </Box>
        <Box sx={{ display: 'flex', pt: 0.5 }}>
          <Typography variant="subtitle2">Schedule Date: </Typography>
          &nbsp;
          <Typography variant="body2">{todayDate}</Typography>
        </Box>
      </Grid>
      <Grid
        p={5}
        sx={{
          backgroundColor: '#F3F4F6',
          '@media print': {
            pt: 0,
          },
        }}
      >
        <Card sx={{ backgroundColor: '#FFF', mx: 8 }}>
          <CardHeader
            title={
              <Box sx={{ display: 'flex', alignItems: 'center' }}>
                <Typography variant="h6">
                  {' '}
                  {selectedTherapist?.uuid === getTherapistProfileData?.response?.data?.providerId
                    ? 'Today’s Patients'
                    : 'Schedule Patients'}
                </Typography>
                {patientTaskList?.length !== undefined && (
                  <Chip
                    label={`${patientTaskList?.length} Patients`}
                    variant="outlined"
                    sx={{ marginLeft: '10px' }}
                  />
                )}
              </Box>
            }
          />
          <Box>
            <PreviewOfPatientTable items={patientTaskList} />
          </Box>
        </Card>
      </Grid>
    </Grid>
  );
};

export default PrintPatient;
